<template>
  <div class="app_container">
    <search class="search-wrapper" @search="searchHandle" @overYear="overYearChange" />
    <div class="table-column-check-list">
      <butn btntype="primary" title="导出" @click="exportExcel" v-permission="'creditStatistics:export'"
        :disabled="list.length <= 0"></butn>

      <el-checkbox-group class="checkbox-group" v-model="tableColumnCheckList">
        <template v-for="(item, index) in tableColumn.filter((value) => value.checkbox)">
          <el-checkbox :key="index" :label="item.prop">
            <div class="checkBoxLabel">{{ item.label }}</div>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <div class="total-credit">
      <span>合计学时：{{ totalLength }}分</span>
      <span>总人数：{{ onlineCode }}人</span>
      <span>平均学时：{{ averageLength }}分</span>
      <span class="tip_msg">（数据更新至昨日23:59）</span>
    </div>
    <el-table ref="pageListTable" :data="list" border
      :cell-style="{ color: '#51627D', fontWeight: 400, textAlign: 'center', padding: '10px 0'}"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500, textAlign: 'center'}">
      <template v-for="(item, index) in tableColumn.filter(
        (ele) => tableColumnCheckList.includes(ele.prop) || !ele.checkbox
      )">
        <el-table-column v-if="item.prop === 'finalCode'" :key="index" class-name="train-list-column" v-bind="item"
           :min-width="item.minWidth">
          <template slot="header">
            <div class="final-code-head">
              <div>培训码</div>
              <i class="el-icon-info icon-info" @click="showExamRuleInfo"></i>
            </div>
          </template>
          <template slot-scope="scope">
            <span v-if="isOverYear">--</span>
            <span v-else :class="getClass(scope.row.finalCode, scope.row)">{{
              scope.row.finalCode == 1 ?
                '绿码' :
                scope.row.finalCode == 2 ?
                  '黄码' :
                  scope.row.finalCode == 3 ?
                    '红码' :
                    '不考核'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.prop == 'selTotalLength'" :key="index + 'selTotalLength'"
          class-name="train-list-column" v-bind="item" :min-width="item.minWidth">
          <template slot-scope="scope">
            <span>{{ scope.row.selTotalLength }}</span>
            <span class="highlight_text">{{ '/' + scope.row.standardOnlineLength }}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.prop == 'userName'" :key="index + 'userName'"
          class-name="train-list-column" v-bind="item" :min-width="item.minWidth">
          <template slot-scope="scope">
            <span class="base-hover-char" @click="toStudyInfo(scope.row)">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :key="index + 'column'" class-name="train-list-column" v-bind="item"
         :min-width="item.minWidth" />
      </template>
    </el-table>
    <el-pagination class="pagination" @size-change="sizeChange" @current-change="pageChange" :current-page="currentPage"
      :page-size="size" :page-sizes="[10, 50, 100, 500, 1000]" layout="total, sizes, prev, pager, next, jumper"
      :total="total" background hide-on-single-page />
    <RuleInfo ref="ruleInfoRef" />
  </div>
</template>

<script>
import { creditStatisticsList, exportCreditStatistics } from "@/api/creditStatistics";
import butn from "@/components/button/index";
import Search from "./search";
import RuleInfo from "@/pages/trainCodeRule/ruleInfo.vue";

export default {
  name: "creditStatistics",
  components: {
    Search,
    butn,
    RuleInfo
  },
  data() {
    return {
      averageLength: 0, // 平均学时
      onlineCode: 0, // 总人数
      totalLength: 0, // 合计学时
      list: [],
      dataname: {},
      currentPage: 1,
      size: 10,
      total: 0,
      isOverYear: false,
      tableColumn: [
        { prop: "userName", label: "姓名", minWidth: "80", },
        { prop: "userBirthday", label: "出生年月", minWidth: "100", checkbox: true },
        {
          prop: "userMobile",
          label: "手机号码",
          minWidth: "110",
          checkbox: true,
        },
        {
          prop: "userSexName",
          label: "性别",
          minWidth: "55",
          checkbox: true,
        },
        {
          prop: "deptName",
          label: "工作单位",
          minWidth: "115",
          checkbox: true
        },
        {
          prop: "unitPosition",
          label: "单位及职务",
          minWidth: "150",
          checkbox: true,
        },
        {
          prop: "leaderTypeName",
          label: "管理主体",
          minWidth: "105",
          checkbox: true,
        },
        {
          prop: "cadreLevelName",
          label: "干部级别",
          minWidth: "100",
          checkbox: true,
        },
        {
          prop: "selTotalLength",
          label: "网络自学学时数",
          child: true,
          checkbox: true,
          minWidth: "120",
        },
        // {
        //   prop: "onlineLength",
        //   label: "18年至今网络培训学时数",
        //   child: true,
        //   checkbox: true,
        //   minWidth: "130",
        // },
        {
          prop: "totalLength",
          label: "近五年集中培训学时数",
          child: true,
          checkbox: true,
          showOverflowTooltip: true,
          minWidth: "120",
        },

        {
          prop: "finalCode",
          label: "培训码",
          child: true,
          checkbox: true,
          minWidth: "100",
        },

      ],
      tableColumnCheckList: [],
    };
  },
  created() {
    this.tableColumn.forEach((value) => {
      if (value.checkbox) {
        this.tableColumnCheckList.push(value.prop);
      }
    });
  },
  methods: {
    //导出
    exportExcel() {
      let param = { ...this.dataname };
      let list = this.tableColumn.filter(
        (ele) => this.tableColumnCheckList.includes(ele.prop) || !ele.checkbox
      );
      let exportList = list.map(value => value.prop);
      param.exportList = exportList;
      exportCreditStatistics(param).then((response) => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function () {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error",
              });
            }
          } catch (e) {
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
        // 更新列表
        this.searchHandle(this.dataname);
      });
    },
    toStudyInfo(item) {
      this.$store.commit("app/setNowStudent", {
        uuid: item.userId,
        userName: item.userName,
        userMobile: item.userMobile,
        unitPosition: item.unitPosition
      });
      this.$router.push({
        path: "/user/studyInfo",
        query: {
          uuid: item.userId
        }
      });
    },
    //   搜索
    searchHandle(params) {
      this.dataname = params;
      this.currentPage = 1;
      this.getList();
    },
    overYearChange(val) {
      this.isOverYear = val;
    },
    // objectSpanMethod({ row, column }) {
    //   if (
    //     [
    //       "main",
    //       "userName",
    //       "userBirthday",
    //       "userMobile",
    //       "deptName",
    //       "leaderTypeName",
    //       "unitPosition",
    //       "totalDays",
    //     ].indexOf(column.property) > -1
    //   ) {
    //     return row.span[0];
    //   }
    // },
    getList() {
      creditStatisticsList({
        ...this.dataname,
        page: this.currentPage,
        limit: this.size,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.total = res.data.total;

        this.averageLength = res.data.averageLength || 0;
        this.onlineCode = res.data.onlineCode || 0;
        this.totalLength = res.data.totalLength || 0;

        let flatList = [];
        if (Array.isArray(res.data.records) && res.data.records.length) {
          flatList = res.data.records;
        }
        this.list = flatList;
      });
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    getClass(val, item) {
      switch (val) {
        case 1:
          return 'greenText'
        case 2:
          return 'yellowText'
        case 3:
          return 'redText'
        default:
          return ''
      }
    },
    getSecondValue(val, item) {
      // if (item.isExam == 1) {
      return val || 0;
      // } else {
      //   return 0;
      // }
    },
    showExamRuleInfo() {
      this.$refs.ruleInfoRef.show();
    }
  },
  computed: {
    examPaperIds() {
      return this.checkArray.map((item) => item.uuid);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}

.table-column-check-list {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  /deep/ .el-checkbox-group {
    display: flex;
    margin-top: 10px;
    margin-left: 20px;
    flex-direction: row;
    flex-wrap: wrap;

    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 5px;
      display: flex;
      flex-direction: row;
    }
  }
}

.checkBoxLabel {
  max-width: 120px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.total-credit {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    margin-right: 15px;
  }

  .tip_msg {
    float: right;
  }
}

.highlight_text {
  color: rgb(52, 60, 74);
  margin-left: 5px;
}
.final-code-head {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .icon-info {
    font-size: 18px;
    margin-left: 4px;
    margin-right: 0 !important;
  }
}
</style>
